@if (admin_override_supported) {
  <ngb-alert
    class="shadow-sm fade show themed-bg administrator-alert"
    role="alert"
    [type]="'light'"
    [dismissible]="false"
  >
    <div class="row">
      <div class="col col-auto">
        <span
          class="d-none d-sm-flex align-items-center justify-content-center notification__bell bg-dark"
        >
          <span class="material-icons notification__bell--icon"> local_police </span>
        </span>
      </div>
      <div class="col">
        <span class="fs-5 fw-bold d-flex align-items-center">
          {{ 'administrator_override' | translate }}
        </span>
        @if (!hide_admin_only) {
          <div class="form-check form-switch mt-3">
            <input
              type="checkbox"
              role="switch"
              id="admin_override"
              class="form-check-input cursor-pointer"
              [(ngModel)]="admin_override"
              [disabled]="disabled"
              [class.opacity-50]="disabled"
              (click)="toggleAdminOverride($event)"
            />
            <label class="form-check-label fw-normal cursor-pointer" for="admin_override">
              {{ 'include_Admin-Only_options' | translate }}
            </label>
          </div>
        }
        @if (hide_review_toggles) {
          <div>
            <div class="form-check form-switch mt-3">
              <div class="mb-2">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="select_all"
                  [(ngModel)]="select_all"
                  (click)="toggleBypassAllProcesses($event)"
                />
                <label class="form-check-label fw-normal cursor-pointer" for="select_all">
                  {{ 'bypass_all_processes' | translate }}
                </label>
              </div>
              <div class="mb-2">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="skip_approval"
                  [(ngModel)]="skip_approval"
                  [disabled]="disabled"
                  [class.opacity-50]="disabled"
                  (click)="toggleSkipApproval($event)"
                />
                <label class="form-check-label fw-normal cursor-pointer" for="skip_approval">
                  {{ 'skip_approval_process' | translate }}
                </label>
              </div>
              <div class="mb-2">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="skip_policy_agreement"
                  [(ngModel)]="skip_policy_agreement"
                  [disabled]="disabled"
                  [class.opacity-50]="disabled"
                  (click)="toggleSkipPolicyAgreement($event)"
                />
                <label
                  class="form-check-label fw-normal cursor-pointer"
                  for="skip_policy_agreement"
                >
                  {{ 'skip_policy_agreement_process' | translate }}
                </label>
              </div>
              <div class="mb-2">
                <input
                  class="form-check-input cursor-pointer"
                  type="checkbox"
                  role="switch"
                  id="suppress_user_email"
                  [(ngModel)]="suppress_user_email"
                  [disabled]="disabled"
                  [class.opacity-50]="disabled"
                  (click)="toggleSupressUserEmail($event)"
                />
                <label class="form-check-label fw-normal cursor-pointer" for="suppress_user_email">
                  {{ 'suppress_user_email' | translate }}
                </label>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </ngb-alert>
}
